<template>
	<div
		class="teaser-medium"
		ref="teaserElement"
		:class="{ 'is-web-teaser': !isNativeDevice }"
		@click="navigateToInnerPage(item.drupal_internal__nid)"
	>
		<img
			ref="imageRef"
			:src="item.field_image.image_style_uri.teaser_medium"
			:alt="item.field_image.meta.alt"
			:class="{ 'lazy-loaded': isLoaded }"
		/>
		<div class="teaser-medium--description">
			<div class="section--top" v-if="approp || quality || item.field_release_year">
				<p v-if="approp" class="age">{{ approp }}</p>
				<p v-if="quality" class="quality">{{ quality }}</p>
				<p v-if="item.field_release_year" class="year">{{ item.field_release_year }}</p>
			</div>
			<p
				class="vl-font-size--16 cutoff-text"
				v-if="item?.field_description"
				v-html="item?.field_description?.processed"
			></p>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { ref, onMounted, computed } from "vue"
	import router from "../../router/router"
	import { Movie } from "../../types/Movie"
	import { Series } from "../../types/Series"
	import { useTaxonomyStore } from "../../stores/taxonomies"
	import { isNativeDevice } from "../../helper"
	import { useTeaserPreview } from "../../composables/useTeaserPreview"
	import { useLazyImage } from "../../composables/useLazyImage"

	const taxonomyStore = useTaxonomyStore()

	const props = defineProps<{
		item: Movie | Series
	}>()

	const emit = defineEmits(["preview-ended"])

	const quality = ref("")
	const approp = ref("")
	const teaserElement = ref<HTMLElement | null>(null)
	const { imageRef, currentSrc, isLoaded, observe } = useLazyImage()

	const imageSrc = computed(() => props.item.field_image?.image_style_uri?.teaser_medium || "")

	onMounted(() => {
		if (props.item?.field_appropriateness?.meta?.drupal_internal__target_id) {
			approp.value = taxonomyStore.getAppropriatenessTitle(
				props.item?.field_appropriateness?.meta?.drupal_internal__target_id
			)
		}
		if (props.item.field_quality.meta?.drupal_internal__target_id) {
			quality.value = taxonomyStore.getQualityTitle(props.item?.field_quality?.meta?.drupal_internal__target_id)
		}

		if (imageSrc.value) {
			observe(imageSrc.value)
		}
	})

	const navigateToInnerPage = async (id: number) => {
		if (props.item?.type?.includes("movie")) {
			router.push({ name: "InnerMovie", params: { id: id } })
		} else if (props.item?.type?.includes("series")) {
			router.push({ name: "InnerSeries", params: { id: id } })
		}
	}
</script>

<style scoped lang="scss">
	.teaser-medium {
		overflow: hidden;
		border-radius: 12px;
		// background: var(--gray);
		background: #534e49;
		&:focus,
		&:hover {
			cursor: pointer;
		}
		&--description {
			// background: var(--gray);
			background: #534e49;
			padding: 20px;
			height: calc(100% - 414px);
			display: flex;
			flex-direction: column;
			font-size: 13px;
			line-height: 18px;
			// border-radius: 0 0 12px 12px;
			@include br.respond-to(br.$tablet-medium) {
				height: calc(100% - 220px);
				padding: 10px;
			}
		}
	}
	p {
		margin: 0;
	}
	.section--top {
		display: flex;
		gap: 15px;
		margin-bottom: 30px;
		@include br.tablet-down {
			margin-bottom: 15px;
			gap: 10px;
		}
	}
	img {
		width: 100%;
		display: block;
		height: auto;
		transition: all 0.3s ease;

		@include br.respond-to(br.$tablet-medium) {
			height: 220px;
			object-fit: cover;
			object-position: center;
		}
	}
	.cutoff-text {
		--max-line: 8;
		display: -webkit-box;
		overflow: hidden;
		// margin-top: auto;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: var(--max-line);
	}
</style>
